import PropTypes from 'prop-types';
import {ValidationError} from '~/SignUpSheets/components/ValidationError/ValidationError';
import {TextEditor} from '~library/organisms/TextEditor';
import './RichTextField.sass';

export const RichTextField = ({
  label,
  value,
  onChange,
  onBlur,
  placeholder,
  maxLength,
  error,
  id = 'description',
  dataQaId,
  innerQuillClassName,
  disabled = false,
}) => {
  const toolbarId = `${id}-toolbar`;

  return (
    <div>
      <TextEditor
        value={value}
        onChange={onChange}
        onBlur={onBlur}
        maxLength={maxLength}
        disabled={disabled}
        id={id}
        label={label}
        error={error}
        toolbarId={toolbarId}
        data-qa-id={dataQaId}
        placeholder={placeholder}
        innerQuillClassName={innerQuillClassName}
        toolbarAlign="left"
      />
      <ValidationError error={error} dataQaIdStub={dataQaId} />
    </div>
  );
};

RichTextField.propTypes = {
  label: PropTypes.string,
  value: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  onBlur: PropTypes.func,
  placeholder: PropTypes.string,
  maxLength: PropTypes.number,
  error: PropTypes.string,
  id: PropTypes.string.isRequired,
  dataQaId: PropTypes.string.isRequired,
  innerQuillClassName: PropTypes.string,
  disabled: PropTypes.bool,
};
